<template>
  <el-card>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item>Proveedores</el-breadcrumb-item>
      <el-button
        type="primary"
        style="float: right"
        size="medium"
        @click="importFromExcel()"
        :loading="excelLoading"
      >
        Importar de un excel
        <i class="el-icon-notebook-2"></i>
      </el-button>
    </el-breadcrumb>
    <br />
    <div class="loading" v-loading="true" v-if="fecthItems.length === 0"></div>
    <template v-else>
      <app-modal-draggable
        v-if="modalDraggable"
        :content="tableQuery"
        :name="'title'"
        :table="'desktop'"
      ></app-modal-draggable>
      <app-table-paginate
        :tableQuery="fecthItems"
        :tableColumns="tableColumns"
        :preview="preview"
        :limit="limit"
        :draggable="true"
        :search="true"
      ></app-table-paginate>
      <br />
      <br />
      <br />
    </template>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_TEMPLATE_DESKTOP } from "@/store/actions.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Draggable from "@/components/Dashboard/Modals/draggable";
import moment from "moment-timezone";

export default {
  name: "List",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-modal-draggable": Draggable,
  },
  async created() {
    this.init();
    this.$root.$on("delete", (id) => {
      this.eliminarRegistro(id);
    });
  },

  data() {
    return {
      tableColumns: [
        {
          prop: "name",
          label: "Nombre fiscal",
        },
        {
          prop: "cif",
          label: "CIF",
        },
        {
          prop: "email",
          label: "Email",
        },
      ],
      tableQuery: {},
      searchQuery: "",
      deleterow: false,
      preview: null,
      templates: false,
      modalDraggable: false,
      excelLoading: false,
      limit: 50,
      access: [],
    };
  },
  watch: {
    $route(to) {
      this.init();
    },
  },
  methods: {
    async init() {
      await this.getPages();
    },

    async getPages() {
      this.tableQuery = [];

      const a = await ApiService.post("dashboard/table", {
        table: "proveedores",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (a.data != "Algo ha fallado") {
        this.tableQuery = a.data;
      } else {
        this.tableQuery = {};
      }
    },
    async eliminarRegistro(id) {
      await ApiService.post("dashboard/delete", {
        table: "proveedores",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id,
      }).then((response) => {
        this.deleterow = response.data;

        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente",
          });
          this.getPages();
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow,
          });
        }
      });
    },
    importFromExcel() {
      var input = document.createElement("input");
      input.type = "file";

      input.onchange = (e) => {
        var file = e.target.files[0];
        this.updateProveedoresWithFile(file);
      };

      input.click();
    },
    async updateProveedoresWithFile(file) {
      this.excelLoading = true;

      let response
      let data = new FormData();
      data.append("file", file);
      data.append("token", localStorage.getItem("token"));
      data.append("project_id", localStorage.getItem("table"));
      try {
        response = await ApiService.post("dashboard/plugin/proveedores/import", data);
      } catch (error) {
        response = { status: false };
      }

      if (response.data.status) {
        await this.getPages();
        this.$notify({
          title: "Proveedores",
          message: "Se han importado correctamente los proveedores",
          type: "success",
        });
      } else {
        this.$notify({
          title: "Proveedores",
          message: "Error al importado los proveedores",
          type: "success",
        });
      }
      this.excelLoading = false;
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.init();
    },
  },
  computed: {
    fecthItems() {
      return this.tableQuery;
    },
    ...mapGetters(["userAccessPlugins"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/proveedores/list.vue